interface StorageData {
  value: unknown;
  expire: number | null;
}

/** 默认缓存过期时间，单位：天 */
const DEFAULT_CACHE_TIME = 7;

/**
 * 创建本地存储对象
 */
export const createLocalStorage = (options?: { expire?: number }) => {
  const DEFAULT_EXPIRE = options?.expire ?? DEFAULT_CACHE_TIME;

  /**
   * 设置缓存数据
   * @param key 键
   * @param value 值
   * @param expire 过期时间，单位：天
   */
  function set<T = unknown>(key: string, value: T, expire: number | null = DEFAULT_EXPIRE): void {
    const storageData: StorageData = {
      value,
      expire: expire !== null ? new Date().getTime() + expire * 24 * 60 * 60 * 1000 : null
    };

    localStorage.setItem(key, JSON.stringify(storageData));
  }

  /**
   * 获取缓存数据
   * @param key 键
   * @param defaultValue 默认值
   */
  function get<T = unknown>(key: string, defaultValue?: T): T | undefined {
    const json = localStorage.getItem(key);
    if (!json) return defaultValue;

    try {
      const storageData: StorageData = JSON.parse(json);
      const { value, expire } = storageData;

      if (expire === null || expire >= Date.now()) {
        return value as T;
      }

      remove(key);
      return defaultValue;
    } catch {
      return defaultValue;
    }
  }

  /**
   * 移除缓存数据
   * @param key 键
   */
  function remove(key: string) {
    localStorage.removeItem(key);
  }

  /**
   * 清空缓存数据
   */
  function clear() {
    localStorage.clear();
  }

  return {
    set,
    get,
    remove,
    clear
  };
};

export const localStg = createLocalStorage(); 